import { Controller } from '@hotwired/stimulus'

export default class ModalHelper extends Controller {

  // Workaround to open modals when this ones are not automatically open with Turbo.visit(/some-route)
  openModal() {
    const modal = document.getElementById('modalContainer');
    if (modal) {
      const modalController = this.application.getControllerForElementAndIdentifier(modal, 'modal');
      modalController?.open();
    }
  }
}
